const round =
    (decimalPlaces: number) =>
    (num: number): number => {
        const divisor = Math.pow(10, decimalPlaces);

        return Math.round(num * divisor) / divisor;
    };

export {round};
